import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { DownloadableCouponRow } from '@models/coupon';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import DownloadIcon from './DownloadIcon';
import useDownloadCoupon from './hooks/useDownloadCoupon';

interface Props {
    coupon:DownloadableCouponRow;
}

function DownloadAbleCoupon({ coupon }:Props) {
    const {
        couponImage, couponTitle, eventEndAt, availableShops,
    } = coupon;
    const { t } = useTranslation('coupon');
    const downloadCoupon = useDownloadCoupon(coupon);
    return (
        <Container fullWidth spacing={16} align='center'>
            <ImageWrapper>
                <Image src={couponImage} alt={couponTitle} width={80} height={80} />
            </ImageWrapper>
            <Column spacing={4}>
                {availableShops !== '전체매장' && (
                    <Text size='s' color={colors.gray8}>{availableShops}</Text>
                )}
                <Text size='lg' fontWeight='medium'>{couponTitle}</Text>
                <Text color={colors.gray7} size='s'>
                    {t('validity', { date: dayjs(eventEndAt).format('YYYY.MM.DD') })}
                </Text>
            </Column>
            <DownloadButton onClick={downloadCoupon} >
                <DownloadIcon color={colors.gray4}/>
            </DownloadButton>
        </Container>
    );
}

const Container = styled(Row)`
    position: relative;
`;

const ImageWrapper = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background-color: var(--color-gray1);
    overflow: hidden;
`;

const DownloadButton = styled.button`
    align-items: center;
    background-color: var(--color-gray1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    padding: 5px;
    position: absolute;
    right: 0;
`;

export default DownloadAbleCoupon;
